<template lang="pug">
    #user-show
        model-form(
            title="Detalle de vendedor"
            :fields="fields"
            ref="form"
            reset-text="restablecer"
            submit-text="editar vendedor"
            v-bind="formData"
            :switchEdit="$can('EDIT_USER')"
            :editable="editableCustomers"
            v-model="modelData"
            @reset="reset"
            @submit="handleSubmit"
            @editable="editableCustomers = $event"
            )
            customers-list(
                v-bind="listData"
                v-if="isCustomerList"
                slot="append"
                :disabled="!editableCustomers"
                v-model="customers"
                )
</template>

<script>
//
import { mapActions, mapState } from 'vuex'
//
import { ModelForm } from '@/components/reusable_components/next'
import { CustomersList } from '@/components/lists'
// import CurrencyUtils from '@/mixins/CurrencyUtils.js'
// import InputValidations from '@/mixins/InputValidations.js'
//
import CommissionService from '@/services/api/commission'
import BranchOfficeService from '@/services/api/branchOffice'
import UserSellerService from '@/services/api/userSeller'

//-
import MdlUserSeller from '../../models/General/GUserSeller'
// import { removeRUTHyphen } from '@/services/RUTFormatter'
//
import UserFields from './partials/fields'
//
export default {
    components: {
        CustomersList,
        'model-form': ModelForm,
    },
    name: 'user-show',
    data: function() {
        //
        return {
            // customRules: {
            //     minLength8(value) {
            //         return value.length >= 8 ? true : 'El largo mínimo es 8'
            //     },
            // },
            fields: UserFields,
            modelData: {},
            isSellerTypeTwo: false,
            // formFields: JSON.parse(JSON.stringify(UserFields)),
            // formData: {
            //     disabled: false,
            //     editable: true,
            //     submitText: 'editar vendedor',
            //     toolbarTitle: 'datos vendedor',
            //     toolbarIcon: 'close',
            // },
            listData: {},
            editableCustomers: false,
            customers: [],

            initialType: null,
            submitData: null,
        }
    },
    computed: {
        ...mapState('SnackbarModalModule', {
            responseConfirm: 'responseConfirm',
        }),
        isGrounsSeller() {
            return this.modelData.seller_type === 2
        },
        isCustomerList() {
            let permission = this.$can('EDIT_USER')
            let sellerType = this.isGrounsSeller
            if (sellerType && permission) {
                return true
            } else return false
        },
        formData() {
            return {
                // editable: true,
                // switchEdit: true,
                loading: this.formLoading,
            }
        },
    },
    methods: {
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        async showSnackbar(type, title, message, callback = () => {}) {
            this.initSnackbar(this.fillSnack(type, title, message, false, 3000))
            callback()
        },
        confirmationRequired(data) {
            return (
                data.seller_type !== this.initialType && data.seller_type !== 2
            )
        },
        handleSubmit(data) {
            console.log('CONFIRM', this.confirmationRequired(data))
            if (this.confirmationRequired(data)) {
                this.submitData = data
                this.resetSnackbarState()
                this.setMessageConfirmSnack('EDITAR')

                //
                let payload = this.fillSnack(
                    'warning',
                    'Cambio de Tipo de Vendedor',
                    'Ha cambiado el tipo de este vendedor.' +
                        'Se desvincularan todos los clientes asociados a este vendedor.' +
                        '¿Está seguro de continuar?',
                    false,
                    0,
                    true
                )
                this.initSnackbar(payload)
            } else this.submitForm(data)
        },
        submitForm: async function(data) {
            let d = { 
                ...data, 
                customer_branch_offices: this
                    .customers
                    .reduce((e, c) => [ ...e, ...c.branch_offices.map(b => b.id) ], [])
            }
            new MdlUserSeller(d)
                .save()
                .then(r => this.handleResponse(r, data))
                .catch(this.showErrorSnackbar)
        },
        handleResponse(response, data = null) {
            if (response.status === 'success') {
                return this.showSuccessSnackbar(this.reset())
                if (data) this.initialType = data.seller_type
            }
            return this.showErrorSnackbar(response)
        },
        showErrorSnackbar(response) {
            this.initSnackbar(
                this.fillSnack('error', 'Error', response.error, false, 3000)
            )
        },
        showSuccessSnackbar() {
            this.initSnackbar(
                this.fillSnack(
                    'success',
                    'Éxito',
                    'Vendedor editado correctamente.',
                    false,
                    3000
                )
            )
        },
        fillFields: async function() {
            UserSellerService.fetchById(this.$route.params.id)
                .then(r => {
                    this.initialType = r.seller_type
                    this.setFormData(r)
                })
                .catch(this.showErrorSnackbar)
        },
        reset() {
            this.editableCustomers = false
            this.formLoading = true
            this.fetch()
            this.$router.go()
        },
        fetch() {
            MdlUserSeller.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },
        setFormData(model) {
            this.modelData = this.formatUserSeller(model)
            this.isSellerTypeTwo = model.seller_type === 2 ? true : false
            this.formLoading = false
        },
        formatUserSeller: function(model) {
            //console.log({ model })
            let obj = {}
            obj.id = this.$route.params.id
            obj.seller_type = model.is_ground_seller ? 2 : model.is_pos_workstation_user ? 3 : 1
            obj.commissions = model.commissions.map(o => o.id)
            obj.rut = model.hr_employee.rut
            obj.g_branch_office_id = model.hr_employee.g_branch_office_id
            obj.names = model.hr_employee.names
            obj.last_name1 = model.hr_employee.last_name1
            obj.last_name2 = model.hr_employee.last_name2
            obj.email = model.hr_employee.email
            //obj.is_ground_seller = false
            return obj
        },
    },
    watch: {
        responseConfirm(v) {
            if (v === 'EDITAR') {
                this.submitForm(this.submitData)
            }
            this.submitData = null
        },
    },
    // mixins: [InputValidations, CurrencyUtils],
    /**
     * lifecycle methods
     */
    beforeMount() {
        this.fillFields()
    },
    mounted() {
        this.setTitle('Detalle vendedor')
    },
}
</script>
